export default {
    LazyWrapper: 'internal',
    LodashWrapper: 'internal',
    MapCache: 'internal',
    SetCache: 'internal',
    add: 'math',
    after: 'function',
    all: 'collection',
    any: 'collection',
    arrayConcat: 'internal',
    arrayCopy: 'internal',
    arrayEach: 'internal',
    arrayEachRight: 'internal',
    arrayEvery: 'internal',
    arrayExtremum: 'internal',
    arrayFilter: 'internal',
    arrayMap: 'internal',
    arrayPush: 'internal',
    arrayReduce: 'internal',
    arrayReduceRight: 'internal',
    arraySome: 'internal',
    arraySum: 'internal',
    ary: 'function',
    assign: 'object',
    assignDefaults: 'internal',
    assignOwnDefaults: 'internal',
    assignWith: 'internal',
    at: 'collection',
    attempt: 'utility',
    backflow: 'function',
    baseAssign: 'internal',
    baseAt: 'internal',
    baseCallback: 'internal',
    baseClone: 'internal',
    baseCompareAscending: 'internal',
    baseCopy: 'internal',
    baseCreate: 'internal',
    baseDelay: 'internal',
    baseDifference: 'internal',
    baseEach: 'internal',
    baseEachRight: 'internal',
    baseEvery: 'internal',
    baseExtremum: 'internal',
    baseFill: 'internal',
    baseFilter: 'internal',
    baseFind: 'internal',
    baseFindIndex: 'internal',
    baseFlatten: 'internal',
    baseFor: 'internal',
    baseForIn: 'internal',
    baseForOwn: 'internal',
    baseForOwnRight: 'internal',
    baseForRight: 'internal',
    baseFunctions: 'internal',
    baseGet: 'internal',
    baseIndexOf: 'internal',
    baseIsEqual: 'internal',
    baseIsEqualDeep: 'internal',
    baseIsFunction: 'internal',
    baseIsMatch: 'internal',
    baseLodash: 'internal',
    baseMap: 'internal',
    baseMatches: 'internal',
    baseMatchesProperty: 'internal',
    baseMerge: 'internal',
    baseMergeDeep: 'internal',
    baseProperty: 'internal',
    basePropertyDeep: 'internal',
    basePullAt: 'internal',
    baseRandom: 'internal',
    baseReduce: 'internal',
    baseSetData: 'internal',
    baseSlice: 'internal',
    baseSome: 'internal',
    baseSortBy: 'internal',
    baseSortByOrder: 'internal',
    baseSum: 'internal',
    baseToString: 'internal',
    baseUniq: 'internal',
    baseValues: 'internal',
    baseWhile: 'internal',
    baseWrapperValue: 'internal',
    before: 'function',
    binaryIndex: 'internal',
    binaryIndexBy: 'internal',
    bind: 'function',
    bindAll: 'function',
    bindCallback: 'internal',
    bindKey: 'function',
    bufferClone: 'internal',
    cacheIndexOf: 'internal',
    cachePush: 'internal',
    callback: 'utility',
    camelCase: 'string',
    capitalize: 'string',
    ceil: 'math',
    chain: 'chain',
    charsLeftIndex: 'internal',
    charsRightIndex: 'internal',
    chunk: 'array',
    clone: 'lang',
    cloneDeep: 'lang',
    collect: 'collection',
    commit: 'chain',
    compact: 'array',
    compareAscending: 'internal',
    compareMultiple: 'internal',
    compose: 'function',
    composeArgs: 'internal',
    composeArgsRight: 'internal',
    concat: 'chain',
    constant: 'utility',
    contains: 'collection',
    countBy: 'collection',
    create: 'object',
    createAggregator: 'internal',
    createAssigner: 'internal',
    createBaseEach: 'internal',
    createBaseFor: 'internal',
    createBindWrapper: 'internal',
    createCache: 'internal',
    createCompounder: 'internal',
    createCtorWrapper: 'internal',
    createCurry: 'internal',
    createDefaults: 'internal',
    createExtremum: 'internal',
    createFind: 'internal',
    createFindIndex: 'internal',
    createFindKey: 'internal',
    createFlow: 'internal',
    createForEach: 'internal',
    createForIn: 'internal',
    createForOwn: 'internal',
    createHybridWrapper: 'internal',
    createObjectMapper: 'internal',
    createPadDir: 'internal',
    createPadding: 'internal',
    createPartial: 'internal',
    createPartialWrapper: 'internal',
    createReduce: 'internal',
    createRound: 'internal',
    createSortedIndex: 'internal',
    createWrapper: 'internal',
    curry: 'function',
    curryRight: 'function',
    debounce: 'function',
    deburr: 'string',
    deburrLetter: 'internal',
    defaults: 'object',
    defaultsDeep: 'object',
    defer: 'function',
    delay: 'function',
    detect: 'collection',
    difference: 'array',
    drop: 'array',
    dropRight: 'array',
    dropRightWhile: 'array',
    dropWhile: 'array',
    each: 'collection',
    eachRight: 'collection',
    endsWith: 'string',
    eq: 'lang',
    equalArrays: 'internal',
    equalByTag: 'internal',
    equalObjects: 'internal',
    escape: 'string',
    escapeHtmlChar: 'internal',
    escapeRegExp: 'string',
    escapeRegExpChar: 'internal',
    escapeStringChar: 'internal',
    every: 'collection',
    extend: 'object',
    fill: 'array',
    filter: 'collection',
    find: 'collection',
    findIndex: 'array',
    findKey: 'object',
    findLast: 'collection',
    findLastIndex: 'array',
    findLastKey: 'object',
    findWhere: 'collection',
    first: 'array',
    flatten: 'array',
    flattenDeep: 'array',
    floor: 'math',
    flow: 'function',
    flowRight: 'function',
    foldl: 'collection',
    foldr: 'collection',
    forEach: 'collection',
    forEachRight: 'collection',
    forIn: 'object',
    forInRight: 'object',
    forOwn: 'object',
    forOwnRight: 'object',
    functions: 'object',
    get: 'object',
    getData: 'internal',
    getFuncName: 'internal',
    getLength: 'internal',
    getMatchData: 'internal',
    getNative: 'internal',
    getView: 'internal',
    groupBy: 'collection',
    gt: 'lang',
    gte: 'lang',
    has: 'object',
    head: 'array',
    identity: 'utility',
    inRange: 'number',
    include: 'collection',
    includes: 'collection',
    indexBy: 'collection',
    indexOf: 'array',
    indexOfNaN: 'internal',
    initCloneArray: 'internal',
    initCloneByTag: 'internal',
    initCloneObject: 'internal',
    initial: 'array',
    inject: 'collection',
    intersection: 'array',
    invert: 'object',
    invoke: 'collection',
    invokePath: 'internal',
    isArguments: 'lang',
    isArray: 'lang',
    isArrayLike: 'internal',
    isBoolean: 'lang',
    isDate: 'lang',
    isElement: 'lang',
    isEmpty: 'lang',
    isEqual: 'lang',
    isError: 'lang',
    isFinite: 'lang',
    isFunction: 'lang',
    isIndex: 'internal',
    isIterateeCall: 'internal',
    isKey: 'internal',
    isLaziable: 'internal',
    isLength: 'internal',
    isMatch: 'lang',
    isNaN: 'lang',
    isNative: 'lang',
    isNull: 'lang',
    isNumber: 'lang',
    isObject: 'lang',
    isObjectLike: 'internal',
    isPlainObject: 'lang',
    isRegExp: 'lang',
    isSpace: 'internal',
    isStrictComparable: 'internal',
    isString: 'lang',
    isTypedArray: 'lang',
    isUndefined: 'lang',
    iteratee: 'utility',
    kebabCase: 'string',
    keys: 'object',
    keysIn: 'object',
    last: 'array',
    lastIndexOf: 'array',
    lazyClone: 'internal',
    lazyReverse: 'internal',
    lazyValue: 'internal',
    lodash: 'chain',
    lt: 'lang',
    lte: 'lang',
    map: 'collection',
    mapDelete: 'internal',
    mapGet: 'internal',
    mapHas: 'internal',
    mapKeys: 'object',
    mapSet: 'internal',
    mapValues: 'object',
    matches: 'utility',
    matchesProperty: 'utility',
    max: 'collection',
    memoize: 'function',
    merge: 'object',
    mergeData: 'internal',
    mergeDefaults: 'internal',
    metaMap: 'internal',
    method: 'utility',
    methodOf: 'utility',
    methods: 'object',
    min: 'collection',
    mixin: 'utility',
    modArgs: 'function',
    negate: 'function',
    noop: 'utility',
    now: 'date',
    object: 'array',
    omit: 'object',
    once: 'function',
    pad: 'string',
    padLeft: 'string',
    padRight: 'string',
    pairs: 'object',
    parseInt: 'string',
    partial: 'function',
    partialRight: 'function',
    partition: 'collection',
    pick: 'object',
    pickByArray: 'internal',
    pickByCallback: 'internal',
    plant: 'chain',
    pluck: 'collection',
    property: 'utility',
    propertyOf: 'utility',
    pull: 'array',
    pullAt: 'array',
    random: 'number',
    range: 'utility',
    reEscape: 'internal',
    reEvaluate: 'internal',
    reInterpolate: 'internal',
    realNames: 'internal',
    rearg: 'function',
    reduce: 'collection',
    reduceRight: 'collection',
    reject: 'collection',
    remove: 'array',
    reorder: 'internal',
    repeat: 'string',
    replaceHolders: 'internal',
    rest: 'array',
    restParam: 'function',
    result: 'object',
    reverse: 'chain',
    round: 'math',
    run: 'chain',
    sample: 'collection',
    select: 'collection',
    set: 'object',
    setData: 'internal',
    shimKeys: 'internal',
    shuffle: 'collection',
    size: 'collection',
    slice: 'array',
    snakeCase: 'string',
    some: 'collection',
    sortBy: 'collection',
    sortByAll: 'collection',
    sortByOrder: 'collection',
    sortedIndex: 'array',
    sortedLastIndex: 'array',
    sortedUniq: 'internal',
    spread: 'function',
    startCase: 'string',
    startsWith: 'string',
    sum: 'collection',
    tail: 'array',
    take: 'array',
    takeRight: 'array',
    takeRightWhile: 'array',
    takeWhile: 'array',
    tap: 'chain',
    template: 'string',
    templateSettings: 'string',
    throttle: 'function',
    thru: 'chain',
    times: 'utility',
    toArray: 'lang',
    toIterable: 'internal',
    toJSON: 'chain',
    toObject: 'internal',
    toPath: 'internal',
    toPlainObject: 'lang',
    toString: 'chain',
    transform: 'object',
    trim: 'string',
    trimLeft: 'string',
    trimRight: 'string',
    trimmedLeftIndex: 'internal',
    trimmedRightIndex: 'internal',
    trunc: 'string',
    unescape: 'string',
    unescapeHtmlChar: 'internal',
    union: 'array',
    uniq: 'array',
    unique: 'array',
    uniqueId: 'utility',
    unzip: 'array',
    unzipWith: 'array',
    value: 'chain',
    valueOf: 'chain',
    values: 'object',
    valuesIn: 'object',
    where: 'collection',
    without: 'array',
    words: 'string',
    wrap: 'function',
    wrapperChain: 'chain',
    wrapperClone: 'internal',
    wrapperCommit: 'chain',
    wrapperConcat: 'chain',
    wrapperPlant: 'chain',
    wrapperReverse: 'chain',
    wrapperToString: 'chain',
    wrapperValue: 'chain',
    xor: 'array',
    zip: 'array',
    zipObject: 'array',
    zipWith: 'array'
};
